import { render, staticRenderFns } from "./WorkRegistrationEndTimeDialog.vue?vue&type=template&id=1955faa1&"
import script from "./WorkRegistrationEndTimeDialog.vue?vue&type=script&lang=js&"
export * from "./WorkRegistrationEndTimeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports